import OrderAction from './orderAction';

export default class UnpaidAction extends OrderAction {
    static NAME = 'unpaid';
    static ASYNCHRONOUS_LIMIT_MIN = 1;
    static POST_ACTION_TOAST = null;

    //only payed
    static condition(order) {
        return order.status === 'valid' && !order.internal_transaction && order.attendee_count > order.attendees_deleted_count && super.payment_plan_condition(order);
    }

    static is_available({ event, feature_flags }) {
        return !(feature_flags.includes('EO_FREE') && !['over', 'closed'].includes(event.status));
    }

    // simple and global
    get needs_confirm() {
        return true;
    }

    get needs_selection() {
        return false;
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
